const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
const apiDocumentationUrl = process.env.REACT_APP_API_DOCUMENTATION_URL || '';
const stripeCustomerUrl = process.env.REACT_APP_STRIPE_CUSTOMER_URL || '';
const frontendAppUrl = process.env.REACT_APP_FRONTEND_APP_URL || '';
const tenantMode = process.env.REACT_APP_TENANT_MODE || 'single';
const isPlanEnabled = process.env.REACT_APP_IS_PLAN_ENABLED === 'true';
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

const frontendUrl = {
  host: process.env.REACT_APP_FRONTEND_URL_HOST || 'localhost:3000',
  protocol: process.env.REACT_APP_FRONTEND_URL_PROTOCOL || 'http',
};

const stripeDashboardUrl =
  process.env.REACT_APP_STRIPE_DASHBOARD_URL ||
  'https://dashboard.stripe.com/dashboard';

const homePageLinks = [
  ['Soaak.com', 'https://soaak.com'],
  ['WordPress Login', 'https://soaak.com/wp-admin'],
  ['Member Login', frontendAppUrl],
  ['Dashboards', 'https://charts.mongodb.com/charts-soaak-ktusn'],
  ['Twilio', 'https://www.twilio.com/console'],
  ['SendGrid', 'https://app.sendgrid.com/'],
  ['Stripe', stripeDashboardUrl],
  ['Mailchimp', 'https://us2.admin.mailchimp.com/'],
  ['Apple Developer Console', 'https://developer.apple.com/'],
  ['Google Play Developer Console', 'https://play.google.com/console'],
  ['Alexa Developer Console', 'https://developer.amazon.com/alexa/console/ask'],
  ['Roku', 'https://developer.roku.com/'],
];

export default {
  frontendUrl,
  backendUrl,
  apiDocumentationUrl,
  tenantMode,
  isPlanEnabled,
  stripePublishableKey,
  stripeCustomerUrl,
  homePageLinks,
  frontendAppUrl,
};
